import React from 'react';
import {
  Col,
  Row
} from 'react-bootstrap';

const InvitationRow = ({ invitation }) => (
  <div className='teamListing resendInvite'>
    <h3 className='hide-md'>{invitation.firstName} {invitation.lastName}</h3>
    <Row className='no-gutter infoRow'>
      <Col xs={12} md={4}>
        <h3 className='hide-sm'>{invitation.firstName} {invitation.lastName}</h3>
        <p><strong><small>Pending invite</small></strong></p>
        <p><small>{invitation.email}</small></p>
      </Col>
    </Row>
  </div>
)

export default InvitationRow;



// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/partials/invitation-row.js